<template>
    <b-card class="mb-5">
        <b-row>
            <b-col md="6">
                <h3>{{$route.name}}</h3>
                <b-breadcrumb>
                    <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                    <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
                </b-breadcrumb>
            </b-col>
            <b-col md="6 mt-3 float-right">
                <b-button variant="primary" class="mb-2 float-right btn-custom" :to="'company/create'"><font-awesome-icon icon="plus"/></b-button>
            </b-col>
        </b-row>
        <div class="border-bottom mb-5"></div>
        <paginated-table ref="dataTable" :can-delete="false" :can-show="true" :can-edit-modal="false" :can-edit="true" :can-reject="false" :can-approve="false" :data-url="apiUrl" :data-key="dataKey" :data-columns="columns">
        </paginated-table>
    </b-card>
</template>
<script>
    import PaginatedTable from '@/components/PaginatedTable'
    export default {
        name: 'company',
        components: {
            PaginatedTable
        },
        data () {
            return {
                dataKey: 'company',
                isActive: 1,
                apiUrl: window.AppConfig.apiUrl + 'company',
                type: null,
                columns: [
                    // {
                    //     key: 'code',
                    //     label: 'ID Company',
                    //     sortable: true
                    // },
                    {
                        key: 'name',
                        label: 'Name',
                        sortable: true
                    },
                    {
                        key: 'isHq',
                        label: '',
                        sortable: false
                    },
                    {
                        key: 'address',
                        label: 'Address',
                        sortable: false
                    }, 
                    {
                        key: 'phone',
                        label: 'Telephone',
                        sortable: true
                    },
                    {
                        key: 'email',
                        label: 'Email',
                        sortable: true
                    },
                    // {
                    //     key: 'statusCompany',
                    //     label: 'Status',
                    //     sortable: true
                    // },
                    {
                        key: 'actions',
                        label: '',
                        sortable: false
                    }
                ],
            }
        },
        methods: {
            // doSubmit () {
            //     this.$validator.validateAll().then(res => {
            //     if (res) {
            //         this.isLoading = true
            //         if (this.model.uuid !== null) {
            //         let model = {}
            //         Object.keys(this.model).forEach(element => {
            //             if (element !== 'uuid') {
            //             model[element] = this.model[element]
            //             }
            //         })
            //         this.$http.patch(this.apiUrl + '/' + this.model.uuid, model).then(response => {
            //             this.isLoading = false
            //             this.$store.dispatch('notification/success', 'Department successfully updated.')
            //             this.$refs.dataTable.getDataTable()
            //             this.resetData()
            //             this.hideModal()
            //         }).catch(error => {
            //             this.isLoading = false
            //             this.$store.dispatch('notification/error', error)
            //         })
            //         } else {
            //         this.$http.post(this.apiUrl, this.model).then(response => {
            //             this.isLoading = false
            //             this.$store.dispatch('notification/success', 'Department successfully added.')
            //             this.hideModal()
            //             this.resetData()
            //             this.$refs.dataTable.getDataTable()
            //         }).catch(error => {
            //             this.isLoading = false
            //             this.$store.dispatch('notification/error', error)
            //         })
            //         }
            //     }
            //     })
            // },
            // doEdit (row) {
            //     this.type = row.type
            //     this.setData(row)
            //     this.$refs['my-modal'].show()
            // },
            // setData (row) {
            //     this.model.uuid = row.uuid
            //     this.model.name = row.name
            //     this.model.exchangeId = row.exchangeId
            // },
            // resetData () {
            //     this.model.uuid = null
            //     this.model.name = null
            //     this.model.exchangeId = null
            //     this.$validator.reset()
            // },
            // showModal(type) {
            //     this.model.name = null
            //     this.model.exchangeId = null
            //     this.model.uuid = null
            //     this.$validator.reset();
            //     this.type = type
            //     this.$refs['my-modal'].show()
            // },
            // hideModal () {
            //     this.resetData()
            //     this.$refs['my-modal'].hide()
            // }
        },
    }
</script>